var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-40 mr-4 mb-4",on:{"click":_vm.openSlider}},[(_vm.photo.is_video)?_c('video',{staticClass:"h-40",attrs:{"controls":""}},[_c('source',{attrs:{"src":_vm.photo.url_video}})]):_c('img',{staticClass:"h-full",attrs:{"src":_vm.photo.url_160h}})])
}
var staticRenderFns = []

export { render, staticRenderFns }